import { Navigate, Route, Routes } from 'react-router-dom';
import ClientDetailPage from './clientDetailPage';
import ClientListPage from './clientListPage';
import ClientRegisterPage from './clientRegisterPage';

const PatientRouter = () => {
  return (
    <>
      <Routes>
        <Route index element={<Navigate to={'list'} />} />
        <Route path=":clientId" element={<ClientDetailPage />} />
        <Route path="list" element={<ClientListPage />} />
        <Route path="add" element={<ClientRegisterPage />} />
      </Routes>
    </>
  );
};

export default PatientRouter;
